import { useTranslation } from 'react-i18next'
import { brandInfo } from '@/mocks/site'
import { photographyServices } from '@/mocks/services'
import PageSeo from '@/components/feature/PageSeo'
import { SITE_URL, businessAddress, businessAreaServed, businessOpeningHours } from '@/utils/schema'

export default function ServicesSeo() {
  const { t } = useTranslation()

  const localBusinessSchema = {
    '@context': 'https://schema.org',
    '@type': 'PhotographyBusiness',
    '@id': `${SITE_URL}/#business`,
    name: brandInfo.name,
    image: brandInfo.logoImage,
    logo: brandInfo.logoImage,
    url: SITE_URL,
    telephone: brandInfo.phone,
    email: brandInfo.email,
    priceRange: '₹₹',
    foundingDate: brandInfo.since,
    description: t('pages.services.description'),
    address: businessAddress,
    areaServed: businessAreaServed,
    openingHoursSpecification: businessOpeningHours,
    makesOffer: photographyServices.map((item) => ({
      '@type': 'Offer',
      itemOffered: {
        '@type': 'Service',
        name: t(`services.items.${item.id}.title`),
        description: t(`services.items.${item.id}.desc`),
        areaServed: businessAreaServed,
      },
    })),
  }

  return (
    <PageSeo
      title={t('seo.services.title')}
      description={t('seo.services.description')}
      path="/services"
      schemas={[localBusinessSchema]}
    />
  )
}